export default {
  id: null,
  nome: null,
  funcionariosId: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/regionalmodel.js